/*
 * Copyright (c) 2021. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import { BwAlertType, BwAlertViewModel } from 'src/types/view-models/bw-alert.view.model';
import ClickableIcon from 'src/bw/clickable-icon/ClickableIcon';
import { IconWarning, IconClose, IconSuccess, IconRight } from '@americanexpress/dls-react';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// stylesheets and icons
import styles from './BwAlert.module.scss';

export default class BwAlert extends Component<BwAlertViewModel> {
    public override render(): ReactComponentElement<any> {
        const action: JSX.Element =
            this.props.action && this.props.onClick ? (
                <Typography
                    variant={TypographyVariants.SUBTEXT}
                    className="link actionLink"
                    key="title"
                    onClick={this.props.onClick}
                >
                    {this.props.action}
                </Typography>
            ) : null;
        let icon: JSX.Element;
        switch (this.props.type) {
            case BwAlertType.BAD:
                icon = <IconWarning className="icon" />;
                break;
            default:
                icon = <IconSuccess className="icon" />;
        }

        return (
            <div className={this.getClasses()} onClick={() => this.props.onClick}>
                <div className="message">
                    {icon}
                    <Typography variant={TypographyVariants.SUBTEXT} key="action">
                        {this.props.text}
                    </Typography>
                    {action}
                </div>
                {this.props.accentIcon && (
                    <div>
                        <ClickableIcon
                            className={styles.accentIcon}
                            icon={<IconRight />}
                            onClick={this.props.onClose}
                        />
                    </div>
                )}
                {this.props.onClose && (
                    <ClickableIcon className="close-icon" icon={<IconClose />} onClick={this.props.onClose} />
                )}
            </div>
        );
    }

    // get CSS classes
    private getClasses(): string {
        const classes: string[] = [];

        if (this.props.className) {
            classes.push(this.props.className);
        }

        if (this.props.fullWidth) {
            classes.push(styles.bwAlertFullWidth);
        } else {
            classes.push(styles.bwAlertDefaultWidth);
        }

        if (this.props.onClose) {
            classes.push(styles.bwAlertWithClose);
        }

        switch (this.props.type) {
            case BwAlertType.BAD:
                classes.push(styles.bwAlertWarning);
                break;
            case BwAlertType.GOOD:
                classes.push(styles.bwAlertSuccess);
                break;
            case BwAlertType.NEUTRAL:
                classes.push(styles.bwAlertNeutral);
                break;
        }

        return classes.join(' ');
    }
}
